import Space from "components/common/space";
import React from "react";
import T from "@marginly/ui/components/typography";
import { Qa } from "../qa";

import { HeroTop } from "../hero-top";
import { ReferSection } from "../refer-section";
import { PrizesSection } from "../prizes-section";
import { RegisterForm } from "../register-form";
import { useMemberInfo } from "components/registration/hooks/use-member-info";
import { HeroLayout } from "../styled/hero-layout";

interface Props {
  contestId: number;
}

export function CamelotUpcoming({ contestId }: Props) {
  const { memberInfo, refetch } = useMemberInfo(contestId);

  const refCode = memberInfo?.refCode;
  return (
    <div>
      <HeroLayout>
        {refCode ? <T headerL>You are registered</T> : <HeroTop />}
        <Space height={50} heightMobile={48} />
        <T body>
          {refCode
            ? "Trading contest starts March 13th."
            : "Register now to secure your spot in the Camelot trading contest with $6,500 in token rewards as prizes. The contest will start on March 13th."}
        </T>
        <Space height={50} heightMobile={48} />
        {!refCode && (
          <RegisterForm
            contestId={contestId}
            onSubmit={refetch}
            refCode={refCode}
          />
        )}
      </HeroLayout>
      <Space height={162} heightMobile={96} />
      <ReferSection refCode={refCode} />
      <Space height={172} heightMobile={72} />
      <PrizesSection />
      <Space height={192} heightMobile={92} />
      <Qa />
    </div>
  );
}
